import "core-js/modules/es.array.push.js";
import uploadImage from '@/components/mapv2/uploadImage';
import mapPosition from '@/components/mapv2/positiongroup';
import sliderInput from '@/components/mapv2/sliderinput';
import fontStyle from '@/components/mapv2/fontstyle';
import gpickr from '@/components/mapv2/gpickr';
import linkwh from '@/components/mapv2/linkwidthheight';
import cdata from './common.js';
export default {
  name: 'slidedata',
  components: {
    uploadImage,
    mapPosition,
    sliderInput,
    fontStyle,
    gpickr,
    linkwh
  },
  meta: {
    title: ''
  },
  props: {
    id: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      leftconflag: true,
      name: '',
      checked1: '',
      activeNames: [],
      titleInfo: [],
      typename: 1,
      checkList: ['0', '1'],
      switchtab1: 'first',
      switchtab2: 'first',
      switchtab3: 'first',
      radio1: 1,
      radio3: 1,
      radio4: 1,
      radio5: 1,
      textarea2: ''
    };
  },
  created() {
    let collapseLen = 22;
    for (let i = 0; i < collapseLen; i++) {
      this.activeNames.push((i + 1).toString());
    }
    this.titleInfo = cdata.MenuData;
  },
  watch: {},
  methods: {
    handleChange(e) {
      console.log(e);
    }
  }
};